export default [

     {
          path: '/infrastructure-resilience',
          name: 'InfrastructureResilience',
          component: () => import("@/views/Page/InfrastructureResilience/InfrastructureResilience.vue"),
          meta: {
               title: 'Prevention Infrastructure Resilience',
          },
     }
];